import { render } from "./FailurePage.vue?vue&type=template&id=d720620a&scoped=true"
import script from "./FailurePage.vue?vue&type=script&lang=js"
export * from "./FailurePage.vue?vue&type=script&lang=js"

import "./FailurePage.vue?vue&type=style&index=0&id=d720620a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d720620a"]])

export default __exports__